module.exports = __webpack_public_path__ + "static/media/marilyn-blue.4dbe1c0a.png";